// extracted by mini-css-extract-plugin
export default {"navContainer":"styles_navContainer__KHIIf","textContainer":"styles_textContainer__JX3W1","showKey":"styles_showKey__IT7Bw"};